<template>
  <div class="cpt-member-manage-custom-range">
    <div class="custom-range-title">{{ title }}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'MemberManageCustomRange',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.cpt-member-manage-custom-range {
  display: flex;
  width: 316px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  background: $d-fl-pp;

  /* 弹层阴影 */
  .custom-range-title {
    display: flex;
    padding: 6px 8px;
    align-items: center;
    gap: 2px;
    align-self: stretch;
    overflow: hidden;

    color: $d-tx-3;
    text-overflow: ellipsis;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.12px;
  }
}
</style>
